import { MesgFilterInfo } from '@dinosband/bv-main-schema/dist/types'
import { QueryFilter } from '@dinosband/bv-messenger-schema'
import { mainStore } from '@dinosband/bv-utils'
import settings from '@dinosband/bv-settings'

import { BvDataCenterContext, ChatRoomAddedPayload, chatRoomQueryOption, CHAT_ROOM_ADDED, SubscriptionManager, _isEqualQueryFilter, _queryFilter } from '../..'
import { MESSAGE_FILTER_UPDATED } from './const'

// const _DEBUG_LOG = process.env.NODE_ENV !== 'production' &&
//                    !!process.env.VUE_APP_MESSENGER_DEBUG_LOG &&
//                    false

// interface _FilterInfo {
//   chatRoomId: number
//   filter?: QueryFilter
// }

export class ChatRoomQueryFilters {

  context: BvDataCenterContext

  private _filters: Record<number, QueryFilter> = {} // number is chatRoomId
  private subscriptions = new SubscriptionManager()

  constructor (context: BvDataCenterContext) {
    this.context = context
    context.queryFilters = this
    // this.init()
    this.initSubscribe()
  }

  // init () {
  //   const queryFilters = settings.mesgFilterInfo
  //   for (const i in queryFilters) {
  //     const chatRoomId = Number(i)
  //     if (!Number.isSafeInteger(chatRoomId) || chatRoomId <= 0) {
  //       continue
  //     }
  //     const filter = _queryFilter(queryFilters[chatRoomId])
  //     if (!filter) {
  //       continue
  //     }
  //     this._filters[chatRoomId] = filter
  //   }
  // }

  private initSubscribe () {
    this.subscriptions.init(this.context.pubsub)
    this.subscriptions.subscribe(CHAT_ROOM_ADDED, (value: ChatRoomAddedPayload) => this.onChatRoomAdded(value))
  }

  cleanup () {
    // this.subscriptions.cleanup()
    this._filters = {}
  }

  queryFilter (chatRoomId: number) {
    return this._filters[chatRoomId]
  }

  updateFilter (chatRoomId: number, info?: MesgFilterInfo) {
    const prev = this._filters[chatRoomId]
    const filter = _queryFilter(chatRoomId, info)
    if (_isEqualQueryFilter(prev, filter)) {
      return
    }
    if (filter) {
      this._filters[chatRoomId] = filter
    } else {
      delete this._filters[chatRoomId]
    }
    this.context.pubsub.publish(MESSAGE_FILTER_UPDATED, chatRoomId)
  }

  private onChatRoomAdded (value: ChatRoomAddedPayload) {
    const channelId = value.channelId
    if (!channelId || channelId < 0) {
      return
    }
    value.chatRooms.forEach((i) => {
      const isAdmin = mainStore.amIAdminOfChannel(channelId)
      const option = chatRoomQueryOption(i.type, isAdmin)
      if (!option) {
        return
      }
      const chatRoomId = i.id
      const filter = _queryFilter(chatRoomId, settings.mesgFilterInfo[chatRoomId], option)
      if (filter) {
        this._filters[chatRoomId] = filter
      } else {
        delete this._filters[chatRoomId]
      }
    })
  }
}

// function checkOldMesgFilterSettings () {
//   if (settings.mesgFilterInfo) {
//     return
//   }
//   if (!settings.messageFilters) {
//     return
//   }
//   const filterInfo: Record<string, MesgFilterInfo> = {}
//   for (const i in settings.messageFilters) {
//     const chatRoomId = Number(i)
//     if (!Number.isInteger(chatRoomId)) {
//       continue
//     }
//     filterInfo[chatRoomId] = {
//       enableFilter: settings.chatRoomIsFiltered[chatRoomId] ?? false,
//       useChannelFilter: true,
//       channelFilter: settings.messageFilters[chatRoomId],
//     }
//   }
//   settings.mesgFilterInfo = filterInfo
//   // settings.messageFilters = _undefined()
//   // settings.chatRoomIsFiltered = _undefined()
// }

// checkOldMesgFilterSettings()